import React from "react";
import ReactDOM from "react-dom/client";
import App from "./App";
import { AuthProvider } from "react-oidc-context";



const cognitoAuthConfig = {
  authority: "https://cognito-idp.us-east-1.amazonaws.com/us-east-1_2a4XZKOnh",
  client_id: "4e9e7i4i49g8ucanu7j4ebgbqs",
  redirect_uri: "https://dashboard.appadvent.in", // Apna custom domain yahan dalein
  response_type: "code",
  scope: "aws.cognito.signin.user.admin email openid profile",
};

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <AuthProvider {...cognitoAuthConfig}>
      <App />
    </AuthProvider>
  </React.StrictMode>
);
